import axios from 'axios';
const instance = axios.create({baseURL: `${window.Configs['ui-base-url']}`});
export default instance